module.exports = {
    production: '5c8f9b4854e894658fe944a2',
    staging: '5c90f5cbf99d28655b6371fa',
    development: '5c90f5d354e894658fe97607',
};
